import { patientNamespace } from "@/store/modules/patient";
import { userNamespace } from "@/store/modules/user";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Colors } from "./util";

@Component({})
export default class ActiveTest extends Vue {
  @Prop(Boolean)
  helpOpen!: boolean;

  @Getter("area", userNamespace)
  area!: string;

  @Action("toggleActiveCase", userNamespace)
  toggleActiveCase!: Function;

  @Action("startActiveCase", userNamespace)
  startActiveCase!: Function;

  @Getter("isActiveTest", patientNamespace)
  isActiveTest!: boolean;

  @Action("setIsActiveTest", patientNamespace)
  setIsActiveTest!: Function;

  @Action("getActiveCases", userNamespace)
  getActiveCases!: Function;

  isHelpOpen: boolean = false;

  get hasResults() {
    return this.tests != null && this.tests.length > 0;
  }

  noteText = "";

  response = {};

  tests = [];

  showThankYou = false;

  isResultsOpen = false;

  get showingPopup() {
    return this.$route.query.popupName;
  }

  get testIconColor() {
    return this.isActiveTest ? Colors.Red : Colors.TestGreen;
  }

  get colorRed() {
    return Colors.Red;
  }

  get isPatientView() {
    return this.$route.params["room"] != null;
  }

  get colorGreen() {
    return Colors.TestGreen;
  }

  get colorBlue() {
    return Colors.LogoBlue;
  }

  get testIcon() {
    return this.isActiveTest ? "stop" : "format_list_numbered";
  }

  get testText() {
    return (this.isActiveTest ? "Stop" : "Start") + " Testing";
  }

  get currentRoomTest(): any[] {
    const area = this.$route.params["area"];
    const room = this.$route.params["room"];
    return this.tests != null && room != null
      ? this.tests.filter(
          (f: any) =>
            f.area != null &&
            f.area == area &&
            f.roomID != null &&
            f.roomID == room
        )
      : [];
  }

  get testIsAlreadyRunning() {
    return this.currentRoomTest.length > 0;
  }

  get currentTestID() {
    return this.currentRoomTest.length > 0 ? this.currentRoomTest[0].logID : "";
  }
  get currentTestDate() {
    return this.currentRoomTest.length > 0
      ? this.fixDate(this.currentRoomTest[0].startDate)
      : "";
  }

  fixDate(dt: string): string {
    return dt.split(".")[0].replace("T", " ");
  }

  toggleHelpOpen() {
    this.isHelpOpen = !this.isHelpOpen;
  }

  toggleActiveCaseTest() {
    if (!this.isActiveTest) {
      this.toggleActiveCase();
      this.setIsActiveTest(true);
    } else {
      this.toggleActiveCase();
      this.setIsActiveTest(false);
    }
  }

  toggleResultsOpen() {
    this.isResultsOpen = !this.isResultsOpen;
  }

  async startActiveCaseTest() {
    if (this.isActiveTest && this.isPatientView) {
      let data: any = {};
      const area = this.$route.params["area"];
      const roomSys = this.$route.params["room"];
      if (area !== "" && roomSys !== "") {
        data.area = area;
        data.roomSys = roomSys;
        this.startActiveCase(data);
        this.refreshTestList();
      }
    }
  }

  get showResponse() {
    return JSON.stringify(this.tests);
  }
  async mounted() {
    this.refreshTestList();
  }

  async refreshTestList() {
    const count = this.tests.length;
    const data = await this.getActiveCases();
    this.tests = data;

    if (!this.isPatientView) {
      this.tests.length > count;
      this.isResultsOpen = true;
    }
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  naviagteToRoom(info: any) {
    const area = info.area;
    const room = info.roomID;
    this.$router.push({ name: "body", params: { area, room } });
  }

  copyLogIdToClipboard() {
    this.copyMessage(this.currentTestID);
    alert('Copied "' + this.currentTestID + '" to clipboard');
  }
  copyMessage(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
}
